import { useQuery } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'

export interface ToolHealthRow {
  tool_name: string
  calls: number
  failures: number
  denied: number
  avg_ms: number | null
  p95_ms: number | null
}

export interface FlaggedAnswer {
  id: number
  created_at: string | null
  user_email: string | null
  verdict: string
  reason: string | null
  note: string | null
  conversation_id: string | null
  message_id: number | null
  question_excerpt: string | null
  answer_excerpt: string | null
  context: Record<string, unknown> | null
}

export interface CarlaHealthSummary {
  window_days: number
  generated_at: string
  turns: { answers: number; linted: number; conversations: number }
  feedback: Record<string, number>
  lint_codes: { code: string; n: number }[]
  tools: ToolHealthRow[]
  users: { user_id: string; calls: number }[]
  flagged_answers: FlaggedAnswer[]
  eval_note: string
}

export function useCarlaHealth(days: number) {
  return useQuery({
    queryKey: ['carla-health', 'summary', days],
    queryFn: () => jsonFetch<CarlaHealthSummary>(`/api/admin/carla-health/summary?days=${days}`),
    staleTime: 60_000,
  })
}
